import { defineMessages } from 'react-intl'

export default defineMessages({
  unableToLogInWithProvidedCredentials: {
    id: 'unableToLogInWithProvidedCredentials',
    defaultMessage: "We didn't recognize the username or password you entered. Please try again.",
  },
  Username: {
    id: 'hfty.username',
    defaultMessage: 'Username',
  },
  Password: {
    id: 'hfty.password',
    defaultMessage: 'Password',
  },
  Login: {
    id: 'hfty.login',
    defaultMessage: 'Login',
  },
  welcomeBack: {
    id: 'hfty.welcomeBack',
    defaultMessage: 'Welcome back !',
  },
  'New Account': {
    id: 'newAccount',
    defaultMessage: 'New Account',
  },
  forgotPassword: {
    id: 'forgotPassword',
    defaultMessage: 'Forgot your password?',
  },
  'ForgotPassword.continue': {
    id: 'ForgotPassword.continue',
    defaultMessage: 'Continue',
  },
  'ForgotPassword.enterUsernameOrEmailError': {
    id: 'ForgotPassword.enterUsernameOrEmailError',
    defaultMessage: 'You must enter your username or email.',
  },
  'ForgotPassword.forgotPasswordInstructions': {
    id: 'ForgotPassword.forgotPasswordInstructions',
    defaultMessage:
      'An email with instructions for resetting ' +
      'your password has been sent to the email address on record for your account.',
  },
  'ForgotPassword.forgotPasswordPrompt': {
    id: 'ForgotPassword.forgotPasswordPrompt',
    defaultMessage: "Enter your username or email below and we'll email you a link to reset your password",
  },
  'ForgotPassword.forgotUserNameAndEmail': {
    id: 'ForgotPassword.forgotUserNameAndEmail',
    defaultMessage: 'Forgot your Username and Email?',
  },
  'ForgotPassword.callUs': {
    id: 'ForgotPassword.callUs',
    defaultMessage: 'Call us',
  },
  'ForgotPassword.goToLoginPage': {
    id: 'ForgotPassword.goToLoginPage',
    defaultMessage: 'Go to Login Page',
  },
  'ForgotPassword.noClientFoundWithThatInformation': {
    id: 'ForgotPassword.noClientFoundWithThatInformation',
    defaultMessage: "We didn't recognize the username or email you entered. Please try again.",
  },
  'ForgotPassword.noEmailOnFilePleaseContactYourLocalHubManager': {
    id: 'ForgotPassword.errorNotConfirmedEmail',
    defaultMessage: `This account has not yet been confirmed. Please check for an email to confirm your account.
    You can change your password once the account has been confirmed. If you are still experiencing problems
    please contact Customer Service at 1-800-845-8171`,
  },
  'ForgotPassword.usernameOrEmail': {
    id: 'ForgotPassword.usernameOrEmail',
    defaultMessage: 'Username or Email',
  },
  noAccount: {
    id: 'noAccount',
    defaultMessage: "Don't have an account?",
  },
  createAccount: {
    id: 'createAccount',
    defaultMessage: 'Create a ',
  },
  needHelp: {
    id: 'needHelp',
    defaultMessage: 'Need help ? Call us: ',
  },
  agPhDHome: {
    id: 'agPhDHome',
    defaultMessage: 'Ag PhD Home',
  },
  feLabs: {
    id: 'feLabs',
    defaultMessage: 'FE Labs',
  },
  noClientFoundWithThatInformation: {
    id: 'noClientFoundWithThatInformation',
    defaultMessage: "We didn't recognize the username or email you entered. Please try again.",
  },
  goToLoginPage: {
    id: 'goToLoginPage',
    defaultMessage: 'Go to Login Page',
  },
  setPassword: {
    id: 'setPassword',
    defaultMessage: 'Set Password',
  },
  passwordsDoNotMatch: {
    id: 'passwordDoNotMatch',
    defaultMessage: 'Your passwords do not match.',
  },
  passwordMustBeAtLeast8Chars: {
    id: 'passwordMustBeAtLeast8Chars',
    defaultMessage: 'Password must be at least 8 characters.',
  },
  confirmPassword: {
    id: 'confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  newPassword: {
    id: 'newPassword',
    defaultMessage: 'New Password',
  },
  changePassword: {
    id: 'changePassword',
    defaultMessage: 'Change Password',
  },
  passwordResetSuccess: {
    id: 'passwordResetSuccess',
    defaultMessage: 'Your password has been successfully reset!',
  },
  existingAgPhdUser: {
    id: 'existingAgPhdUser',
    defaultMessage: 'Existing AgPhD Soil Test user?',
  },
  migrateAction: {
    id: 'migrateAction',
    defaultMessage: 'Migrate your data to the new system here',
  },
  expiredPasswordLink: {
    id: 'expiredPasswordLink',
    defaultMessage: 'Sorry, this password reset link has expired.',
  },
  redirectNewPasswordLink: {
    id: 'redirectNewPasswordLink',
    defaultMessage: 'Please reset your password again here.',
  },
  privacyPolicy: {
    id: 'privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
})
